import { Tabs } from "antd";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import AccessLogTab from "./AccessLogTab";
import ActionLogTab from "./ActionLogTab";
import "./SystemLogMaster.scss";

const TAB_KEYS = ["access", "action"] as const;
type TabKey = typeof TAB_KEYS[number];

// Nhật ký hệ thống, phương án A: hai tab cùng một khuôn (hàng lọc rồi bảng).
// Dữ liệu đang là dữ liệu giả trong system-log-demo-data.ts.
function SystemLogMaster() {
  const history = useHistory();
  const location = useLocation();

  // Tab giữ trên URL để chép link gửi nhau mở đúng tab.
  const activeTab = React.useMemo<TabKey>(() => {
    const tab = new URLSearchParams(location.search).get("tab") as TabKey;
    return TAB_KEYS.includes(tab) ? tab : "access";
  }, [location.search]);

  const handleChangeTab = React.useCallback(
    (key: string) => {
      const params = new URLSearchParams(location.search);
      params.set("tab", key);
      history.replace({ search: params.toString() });
    },
    [history, location.search]
  );

  return (
    <div className="system-log">
      <div className="system-log__head">
        <h1 className="system-log__title">Nhật ký hệ thống</h1>
        <p className="system-log__meta">
          Ai đã vào hệ thống và đã tác động gì lên thiết bị của khách.
        </p>
      </div>

      <section className="system-log__card">
        <Tabs
          className="system-log__tabs"
          activeKey={activeTab}
          onChange={handleChangeTab}
          destroyInactiveTabPane
        >
          <Tabs.TabPane tab="Lịch sử truy cập" key="access">
            <AccessLogTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Lịch sử tác động" key="action">
            <ActionLogTab />
          </Tabs.TabPane>
        </Tabs>
      </section>
    </div>
  );
}

export default SystemLogMaster;
